
import { Badge } from "@/components/ui/badge";
import { memo } from "react";
import { getStatusLabel, getStatusVariant } from "@/utils/statusMapping";
import { cn } from "@/lib/utils";

interface StatusBadgeProps {
  status: string;
}

const StatusBadge = memo(({ status }: StatusBadgeProps) => {
  const displayStatus = getStatusLabel(status);
  const variantClass = getStatusVariant(status);

  // Use outline so Badge's default hover:bg-primary/80 doesn't wash out status colors
  return (
    <Badge variant="outline" className={cn(variantClass, "border")}>
      {displayStatus}
    </Badge>
  );
});

StatusBadge.displayName = "StatusBadge";

export default StatusBadge;
